import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";

const AuthLayout = () => (
    <>
        <Navbar />
        <div className="page-container">
            <Outlet />
        </div>
    </>
);

export default AuthLayout;
